import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { ActivatedRoute } from "@angular/router";
import { ElasticService } from "./../../services/elastic";

import { FormGroup, FormControl, Validators } from "@angular/forms";
// Models
import { Attachment } from "./../../models/attachment";
import { Club } from "./../../models/club";
// External
import { AngularFireAuth } from "angularfire2/auth";
import { AngularFireDatabase } from "angularfire2/database";
import { FirebaseApp } from "angularfire2";
import * as moment from "moment";
import { DatePipe } from "@angular/common";
import { MatChipInputEvent } from "@angular/material/chips";
import { COMMA, ENTER } from "@angular/cdk/keycodes";
import * as lodash from "lodash";
import { OAuthService } from "app/services/o-auth";
@Component({
  templateUrl: "./update.event.component.html",
})
export class UpdateEventComponent {
  public form: FormGroup;
  public offerData: any;
  public clubs: Array<Club>;
  public query: string;
  private typingDelay: any;
  // public orderData: any;
  public loading: boolean;
  public attachmentFiles: any;

  public minEndDate: Date;
  public offer: any;
  public postId: string;
  public author: string;
  public minFrom: any;
  public minTill: any;
  public benefits: Array<any>;
  public features: Array<any>;
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  public user: any;
  isBankAttached = false;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private firebase: FirebaseApp,
    private datePipe: DatePipe,
    private fireAuth: AngularFireAuth,
    private oAuthService: OAuthService,
    private fireDatabase: AngularFireDatabase,
    private elasticSearch: ElasticService
  ) {
    this.attachmentFiles = {};
    this.offerData = {
      offerName: "",
      validFrom: "",
      validTill: "",
      eventDate: "",
      uid: this.fireAuth.auth.currentUser.uid,
      offerType: "",
      sellingPrice: "",
      offerPrice: "",
      shippingPrice: 0,
      isStockUnlimited: false,
      stock: "",
      shortDescription: "",
      longDescription: "",
      creationDate: moment().unix(),
      tnc: "",
      club: {
        cid: "",
        clubName: "",
        city: "",
        country: "",
        state: "",
        location: {},
      },
    };
    this.user = this.oAuthService.getClub();

    this.benefits = [];
    this.features = [];

    this.minFrom = new Date();
    this.minTill = new Date();
  }
  remove(i) {
    this.offerData.images.splice(i, 1);
  }
  ngOnInit() {
    this.author = this.route.snapshot.paramMap.get("author");
    this.postId = this.route.snapshot.paramMap.get("id");

    if (this.author && this.postId) {
      this.initData();
    }
  }
  public initData() {
    this.fireDatabase
      .object(`/user-offers/${this.author}/${this.postId}`)
      .subscribe((result) => {
        this.offerData = result;
        // console.log('offer    ', this.offerData);
        this.offerData.validFrom = new Date(result.validFrom);
        this.offerData.validTill = new Date(result.validTill);
        this.offerData.eventDate = new Date(result.eventDate);
        if (!this.offerData.images) {
          this.offerData.images = [this.offerData.image];
        }
        if (this.offerData.benefits) {
          this.offerData.benefits.map((b) => {
            this.benefits.push({ name: b });
            return b;
          });
        }
        if (this.offerData.features) {
          this.offerData.features.map((b) => {
            this.features.push({ name: b });
            return b;
          });
        }
        if (result.isStockUnlimited) {
          this.offerData.isStockUnlimited = true;
        } else {
          this.offerData.isStockUnlimited = false;
        }
      });
  }

  private uploadFile(): Promise<any> {
    var promises = [];
    if (this.attachmentFiles && this.attachmentFiles.cropped) {
      for (var i = 0; i < this.attachmentFiles.cropped.length; i++) {
        const element = this.attachmentFiles.cropped[i];
        const newImage = new Promise((resolve, reject) => {
          const filename = `${moment().unix()}.${Math.floor(
            Math.random() * 900 + 100
          )}`;
          this.firebase
            .storage()
            .ref(`/attachments/${this.fireAuth.auth.currentUser.uid}`)
            .child(filename)
            .put(element.file)
            .then((result) => resolve(result))
            .catch((error) => reject(error));
        });
        promises.push(newImage);
      }
    }

    return Promise.all(promises);
  }

  public changeAttachment(attachments) {
    this.attachmentFiles = attachments;
  }
  public submit(): void {
    let temp = this.offerData.isStockUnlimited == false && !this.offerData.stock;
    if(temp)
    {
      alert("Please fill stocks count");
      return;
    }
     if (
      this.offerData.offerName == "" ||
      this.offerData.club.clubName == "" ||
      !this.offerData.validTill ||
      !this.offerData.validFrom ||
      this.offerData.offerType == "" ||
      !this.offerData.offerType ||
      this.offerData.sellingPrice == "" ||
      !this.offerData.sellingPrice ||
      this.offerData.offerPrice == "" ||
      !this.offerData.offerPrice ||
      this.offerData.sellingPrice == "" ||
      !this.offerData.sellingPrice ||
      this.offerData.shortDescription == "" ||
      this.offerData.longDescription == "" ||
      this.offerData.tnc == ""
    ) {
      alert("Please fill all mandatory information.");
      return;
    }
    if (this.offerData.offerName == "") {
    } else {
      if (this.user.type == 1) {
        this.fireDatabase
          .object(`/users/` + this.offerData.club.cid)
          .subscribe((result) => {
            this.offerData.club.email = result.email;
          });
      }
      if (
        this.offerData.sellingPrice == null ||
        this.offerData.sellingPrice == undefined ||
        this.offerData.sellingPrice == ""
      ) {
        this.offerData.sellingPrice = this.offerData.offerPrice;
      }
      this.loading = true;
      const df = this.datePipe.transform(
        this.offerData.validFrom,
        "yyyy-MM-dd"
      );
      this.offerData.validFrom = df;

      const dt = this.datePipe.transform(
        this.offerData.validTill,
        "yyyy-MM-dd"
      );
      const dt1 = this.datePipe.transform(
        this.offerData.eventDate,
        "yyyy-MM-dd"
      );
      this.offerData.eventDate = dt1;
      this.uploadFile()
        .then((fileResult) => {
          var urls = [];
          for (var i = 0; i < fileResult.length; i++) {
            var element = fileResult[i];
            urls.push(element.downloadURL);
          }
          this.offerData.images = this.offerData.images.concat(urls);
          if (this.offerData.images && this.offerData.images.length > 0)
            this.offerData.image = this.offerData.images[0];
          this.offerData.benefits = {};
          for (let b = 0; b < this.benefits.length; b++) {
            const element = this.benefits[b];
            this.offerData.benefits[b] = element.name;
          }
          this.offerData.features = {};
          for (let b = 0; b < this.features.length; b++) {
            const element = this.features[b];
            this.offerData.features[b] = element.name;
          }
          let tempDate = new Date(this.offerData.validTill);
          this.offerData.validTill =
            tempDate.getFullYear() +
            "-" +
            (tempDate.getMonth() + 1 < 10
              ? "0" + (tempDate.getMonth() + 1)
              : tempDate.getMonth() + 1) +
            "-" +
            tempDate.getDate();

          this.fireDatabase.database
            .ref(
              `/user-offers/${this.offerData.club.cid}/${this.offerData.$key}`
            )
            .update(this.offerData)
            .then((postResult) => {
              switch (this.offerData.offerType) {
                case 1:
                  alert("Voucher Updated Successfully");

                  break;
                case 2:
                  alert("Product Updated Successfully");

                  break;
                case 3:
                  alert("GH Event Updated Successfully");

                  break;
              }
              this.router.navigate(["/components/events"]);
            })
            .catch((error) => {
              this.error(error);
            });
        })
        .catch((error) => {
          this.error(error);
        });
    }
  }

  private error(error): void {
    console.error(error);

    alert("Sorry, something went wrong!");

    this.loading = false;
  }
  chooseClub(club: Club) {
    if (!club) {
      return;
    }
    if (club.bank) {
      if (club.bank.stripe_user_id) {
        this.offerData.club.cid = club.$key;
        this.offerData.club.clubName = club.name;
        this.offerData.club.location = club.location;
        this.offerData.club.city = club.city;
        this.offerData.club.state = club.state;
        this.offerData.club.country = club.country;
        if (club.avatar_thumb) {
          this.offerData.club.clubImage = club.avatar_thumb;
        }

        if (club.avatar_thumb) {
          this.offerData.club.email = club.avatar_thumb;
        } else {
          if (club.email) {
            if (this.user.type == 1) {
              this.fireDatabase
                .object(`/users/` + this.offerData.club.cid)
                .subscribe((result) => {
                  this.offerData.club.email = result.email;
                });
            } else {
              this.offerData.club.email = club.email;
            }
          }
        }
        if (club.db_phone) {
          this.offerData.club.phone = club.db_phone;
        }
      }

      this.isBankAttached = false;
    } else {
      this.isBankAttached = true;
    }
    this.offerData.club = club;

    this.clubs = [];
  }
  changeQuery() {
    clearTimeout(this.typingDelay);
    // console.log("change")
    //  this.onChange.emit();

    this.typingDelay = setTimeout(() => {
      this.searchMention();
    }, 400);
  }

  onFocus() {
    this.searchMention();
  }
  searchMention() {
    const queryParams = {
      index: "users",
      type: "club",
      size: 10,
      "body/query/bool/must/query_string/query": `${this.offerData.club.clubName}*`,
      "body/query/bool/must/query_string/fields": [
        "name^10",
        "city^2",
        "state",
        "country",
      ],
    };

    this.elasticSearch
      .search(queryParams)
      .then((result) => {
        this.clubs = [];
        // console.log(result)
        lodash.forEach(result["hits"], (item) => {
          // console.log(item);
          const club = lodash.assign({ $key: item["_id"] }, item["_source"]);
          this.clubs.push(club);
          // console.log(this.clubs)
        });
      })
      .catch((error) => {
        console.error(error);
      });
  }

  addBenefit(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    // Add our fruit
    if ((value || "").trim()) {
      let t = this.benefits.find(
        (q) =>
          q.name.trim().toLocaleLowerCase() == value.trim().toLocaleLowerCase()
      );
      if (!t) this.benefits.push({ name: value.trim() });
    }

    // Reset the input value
    if (input) {
      input.value = "";
    }
  }

  removeBenefit(child): void {
    this.benefits.splice(child, 1);
  }
  addFeature(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    // Add our fruit
    if ((value || "").trim()) {
      let t = this.features.find(
        (q) =>
          q.name.trim().toLocaleLowerCase() == value.trim().toLocaleLowerCase()
      );
      if (!t) this.features.push({ name: value.trim() });
    }

    // Reset the input value
    if (input) {
      input.value = "";
    }
  }

  removeFeature(child): void {
    this.features.splice(child, 1);
  }
}
